var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[(_vm.isLoading)?_c('div',[_c('Loader')],1):_c('div',[(_vm.stat == 1)?_c('div'):_c('div',[_c('noData')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" Profile")])
}]

export { render, staticRenderFns }